import React, { ReactElement, useState } from "react";
import ToggleMfaStepContext from "../contexts/ToggleMfaStepContext";
const ToggleMfaStepProvider = ({ children }: { children: ReactElement }) => {
  const [mfaStepEnabled, setMfaStepEnabled] = useState(false);
  const toggleMfaStep = () => setMfaStepEnabled(!mfaStepEnabled);

  return (
    <ToggleMfaStepContext.Provider value={{ mfaStepEnabled, toggleMfaStep }}>
      {children}
    </ToggleMfaStepContext.Provider>
  );
};

export default ToggleMfaStepProvider;
